import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  totalAmount: {
    id: 'donater.form.total_amount',
    defaultMessage: 'Total amount',
  },
  youCover: {
    id: 'donater.form.you_cover',
    defaultMessage: 'You cover a fee of {value}',
  },
})
